<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <div class="table-responsive">
              <table id="sorting-table" class="table mb-0">
                <thead>
                  <tr>
                    <th>تصویر</th>
                    <th>نام زمین</th>
                    <th>نوع زمین</th>
                    <th>نوع توپ</th>
                    <th>ورودی</th>
                    <th>قوانین</th>
                    <th>xp</th>
                    <th>وضعیت</th>
                    <th>جزییات</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="ground in grounds" :key="ground._id">
                    <td>
                      <img
                        v-if="ground.imageUrl"
                        :src="ground.imageUrl"
                        alt=""
                        style="max-height: 40px; max-width: 60px; object-fit: contain;"
                      />
                      <span v-else>-</span>
                    </td>
                    <td>{{ ground.groundName }}</td>
                    <td>{{ ground.groundType }}</td>
                    <td>{{ ground.ballTheme }}</td>
                    <td>{{ ground.groundBetCoin }}</td>
                    <td>
                      {{
                        ground.winRoles.goal.isActive
                          ? `${ground.winRoles.goal.maxGoal} گل`
                          : `${ground.winRoles.time.maxTime} ثانیه`
                      }}
                    </td>
                    <td>{{ ground.winnerShare }}</td>
                    <td>{{ ground.isAvailable ? 'فعال' : 'غیر فعال' }}</td>
                    <td>
                      <router-link :to="{ path: '/dashboard/ground', query: { id: ground._id } }">مشاهده</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import groundService from '../../../../services/ground';
export default {
  name: 'grounds',
  data() {
    return {
      grounds: [],
    };
  },
  created() {
    this.getGrounds();
  },
  methods: {
    async getGrounds() {
      try {
        const condition = {};
        const resData = await groundService.getAllGrounds(condition);
        console.log(resData);
        this.grounds = resData;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
